export const quoteListFilter = {
  allQuotes: "All Quotes",
  myQuotes: "My Quotes",
  myClientQuotes: "My Clients",
  myTeamsQuotes: "My Team",
  myAgentsQuotes: "My Agents",
};
